/*
  Stepped Bundle: Pillow Custom Functionality
*/

//mount the marlow card via sections api only if you're on a mib pillow for a stepped bundle, and memory foam is selected as your fill
const mountMarlowCard = () => {
  if (!document.querySelector('#shopify-section-marlow-product-info-card')) {
    fetch('?section_id=marlow-product-info-card')
      .then((res) => res.text())
      .then((data) => {
        let infoCardModule = document.createElement('div');
        infoCardModule.innerHTML = data;
        infoCardModule = infoCardModule.firstChild;
        if (infoCardModule.childNodes.length > 0) document.querySelector('.ProductForm__Actions').insertAdjacentElement('beforebegin', infoCardModule);
      });
  } else toggleMarlowCard();
};

const toggleMarlowCard = (value) => {
  value == 'hide' ? document.querySelector('#shopify-section-marlow-product-info-card')?.classList?.add('card--hidden') : document.querySelector('#shopify-section-marlow-product-info-card')?.classList?.remove('card--hidden');
};

export const handleUniqueOptionValues = (data) => {
  const { value, props, index, store } = data;
  const variants = props.data?.item?.variants;
  const { name } = props.option;
  let matchedOptionValues = [];
  let matchedVariantValues = [];

  //find all the variants where the selected option value exists, then return all the option values within those variants that are compatible with the selected option value
  variants.forEach((variant) => {
    const selectedOptions = [...variant.selectedOptions];
    const matchedVariants = selectedOptions.filter((selectedOption) => selectedOption.value == value);
    if (matchedVariants.length > 0) {
      const matchedOptions = variant.selectedOptions.filter((option) => option.value != value);
      matchedOptionValues.push(matchedOptions);
      matchedVariantValues.push(variant);
    }
  });

  //clean the data: through an array of compatible option values with the currently selected value, return only the unique option values
  const uniqueOptionValues = [...new Set(matchedOptionValues.flat().map((option) => option.value))];

  //when interacting with the first option list (i.e. fill), this should dictate what options are shown for the third option list (i.e. support).
  if (index.value == 0) {
    document.querySelectorAll(`.ProductForm .OptionList__Items:not([data-name=${name}]) .OptionList__Item`).forEach((item) => {
      const optionValue = item.getAttribute('data-value');
      uniqueOptionValues.includes(optionValue) ? item.setAttribute('data-inactive', false) : item.setAttribute('data-inactive', true);
    });

    //when a selection in the first option list has been made, this will toggle what's visible and hidden on the third option list
    //toggle the marlow info card depending on what is selected in the first option list
    if (value == 'Down') {
      toggleMarlowCard('hide');
    } else if (value == 'Memory Foam') {
      store.isSteppedBundle ? store.componentSelect(2, { name: 'Support', value: 'Adjustable' }) : store.select(2, { name: 'Support', value: 'Adjustable' });
      mountMarlowCard();
    } else if (value == 'Down Alternative') {
      toggleMarlowCard('hide');
    }
  }
  //get an array of the unique variant options shown when an option list is partially hidden
  //use the length of this array in a computed value to conditionally hide option lists that are one option long
  let uniqueValues = [];
  matchedVariantValues.forEach((variant) => {
    uniqueValues.push(variant.selectedOptions[2]);
  });
  uniqueValues = [...new Set(uniqueValues.map((option) => option.value))];

  return uniqueValues.length;
};

export const formatValue = (value) => {
  const formattedValue = value?.replace('Alternative', 'Alt');
  return formattedValue;
};

//this listens to dynamic cart updates in real time. it's used primarily for the gift card as rise.ai calls /add.js without firing our custom event theme:add-to-cart, and there's no callback function available for us.
export class CartWatcher {
  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }

  async fetchCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  storeCart(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
  }

  storedCart() {
    return JSON.parse(localStorage.getItem('cart')) || { items: [] };
  }

  findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) => l.filter((li) => !r.some((ri) => li.key == ri.key));
    let result = {
      added: onlyInLeft(newCart.items, oldCart.items),
      removed: onlyInLeft(oldCart.items, newCart.items),
    };

    oldCart.items.forEach((oi) => {
      const ni = newCart.items.find((i) => i.key == oi.key && i.quantity != oi.quantity);
      if (!ni) return;
      let quantity = ni.quantity - oi.quantity;
      let item = { ...ni };
      item.quantity = Math.abs(quantity);
      quantity > 0 ? result.added.push(item) : result.removed.push(item);
    });

    return result;
  }

  async emitCartChanges() {
    const newCart = await this.fetchCart();
    const oldCart = this.storedCart();
    const changes = this.findCartChanges(oldCart, newCart);

    const event = new CustomEvent('theme:cart-changed', { detail: changes });
    window.dispatchEvent(event);

    this.storeCart(newCart);
  }

  observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges();
        }
      });
    });
    cartObserver.observe({ entryTypes: ['resource'] });
  }
}

export const getDYRecommendations = (id, limit) =>
  new Promise((resolve, reject) => {
    DYO.recommendationWidgetData(id, {}, (error, data) => {
      if (error) reject([]);

      const { slots } = data;
      const recommendations = slots.reduce((arr, slot) => {
        if (!slot.item) return arr;
        arr.push({
          cardType: 'PRODUCT',
          handle: slot.item.group_id,
          sku: slot.item.sku,
        });
        return arr;
      }, []);

      /** @var {Array} uniqueRecommendations removes potential redundencies in the DY responses. Filters out products by handle */
      const uniqueRecommendations = Array.from(new Map(recommendations.map((item) => [item['handle'], item])).values()).splice(0, limit);

      resolve(uniqueRecommendations);
    });
  });

/**
 * @name getRecommendationUrl
 * @function
 * @param {String,Number} id is the product id from the product
 * @param {Number} limit is the amount of products to be recommended
 * @param {String} intent is the strategy for recommendations
 * @returns {String} returns the URL to be used for Search & Discovery's Product Recommendation API
 * @example "recommendations/products?product_id=12345690123&limit=3&section_id=product-recs-1721402770127&intent=related"
 */
const getRecommendationUrl = (id, limit, intent) => {
  if (!id) return false;
  const url = `/recommendations/products.json?product_id=${id}&limit=${limit}&section_id=product-recommendations&intent=${intent}`;
  return url.trim();
};

/**
 * @name fetchRecommendations
 * @function
 * @param {String,Number} id is the product id from the product
 * This parameter is required and the function will return false if not provided.
 *
 * @param {Number} limit is the amount of products to be recommended.
 * If the parameter is not present. The floor is 1, the ceiling is 10. A value of 3 will be used as the default.
 *
 * @param {String} intent is the strategy for recommendations
 * If the parameter is not present. A value of 'related' will be used as the default.
 *
 * @returns {Object} returns the response from Shopify's Product Recommendation API
 * @example { "intent": "related", "products": [{ product }, { product }, { product }]}
 */

const fetchRecommendations = async (id, limit, intent) => {
  if (!id) return false;
  const recommendations = getRecommendationUrl(id, limit, intent);
  if (!recommendations) return false;

  try {
    const request = await fetch(recommendations);
    return request.json();
  } catch (err) {
    console.log(err);
  }
};

/**
 * @name getShopifyRecommendations
 * @function
 *
 * @var {Number, String} id is the product ID to base our recommendation query off of.
 *
 * @var {Object} response is the returned value from the function fetchRecommendations.
 * Optionally, you can pass additional (optional) arguments for product count(accepts 1-10). If no argument exists, the default value is 3.
 * Lastly, a string of either 'complementary' or 'related'. If the value is 'related', you do not need to pass this as an argument since 'related' is the default value.
 * @example const response = { "intent": "related", "products": [{ product }, { product }, { product }]}
 *
 * Because our modules like Upsell, Product Sliders, and Product Grid are leveraging the GraphQL API,
 * we should ignore most of the returned data besides the handles, sku.
 * @var {Array} products is the returned value of the reduce method of all product handles.
 *
 * @returns {Object} the returned value of product handles and recommendation intent.
 */

const getShopifyRecommendations = async (id, limit = 3, intent = 'related') => {
  if (!id) return;
  const response = await fetchRecommendations(id, limit, intent);
  /**
   * Other Usage Examples
   * @example const response = await fetchRecommendations(id, 10);
   * @example const response = await fetchRecommendations(id, 7, 'complementary');
   */

  const products = response.products.reduce((arr, item) => {
    const isMoveInBundleComponent = item?.handle.includes('mib') ?? false;
    if (!item || isMoveInBundleComponent) return arr;

    arr.push({
      cardType: 'PRODUCT',
      handle: item.handle,
      sku: item.variants[0].sku,
    });

    return arr;
  }, []);

  return products;
};

export const determineRecommendation = async (strategy, limit = 4) => {
  const items = await getDYRecommendations(parseInt(strategy), limit);
  return items;
};
